
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history', // 使用HTML5 History模式，需要服务器支持或前端路由库如vue-router的history模式插件支持（例如vue-router-hashbang）
    base: process.env.BASE_URL, // 通常不需要手动设置，除非你有特殊的路径配置需求
    // routes, // 短捷方式，等同于routes: routes
  });
   
  export default router; // 导出router实例，以便在Vue实例中使用